export default __webpack_public_path__ + "static/media/survey-sport.6f7e19bf.png";